import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleHeader from './SimpleHeader';
import Footer from './Footer';
import MobileFooter from './MobileFooter';

const ConditionalLayout = ({ children }) => {
  const location = useLocation();
  
  // Define routes that should not have header/footer
  const excludedRoutes = [
    '/admin-dashboard',
    '/corporate-dashboard',
    '/customer-dashboard',
    '/admin',
    '/partner'
  ];
  
  // Check if current route should be excluded from header/footer
  const isExcludedRoute = excludedRoutes.some(route => location.pathname.startsWith(route));
  
  if (isExcludedRoute) {
    // For excluded routes, render only the children without header/footer
    return <>{children}</>;
  }
  
  // Routes that hide the global header/footer on mobile only (page renders its own mobile header)
  const hideChromeOnMobile = ['/hotels/results'].includes(location.pathname)
    || /^\/hotels\/[^/]+$/.test(location.pathname)
    || /^\/hotels\/[^/]+\/rooms\/[^/]+\/book$/.test(location.pathname)
    || /^\/hotel-details-api\/[^/]+$/.test(location.pathname)
    || location.pathname === '/hotel-details-api/book'
    || location.pathname === '/hotels/payment'
    || /^\/buses\/[^/]+\/select-seat$/.test(location.pathname)
    || location.pathname === '/flights/travellers'
    || location.pathname === '/flights/roundtrip-travellers'
    || location.pathname === '/flights/booking'
    || location.pathname === '/flights/roundtrip-booking'
    || location.pathname === '/flights/payment'
    || location.pathname === '/flight/payment';

  // Routes that only show the mobile footer (hide desktop footer on mobile).
  // Flight results renders its own app-style mobile header + sticky filters.
  const hideDesktopFooterOnMobile = location.pathname === '/buses'
    || location.pathname === '/flights'
    || location.pathname === '/flights/results'
    || location.pathname === '/flights/roundtrip-results';

  const isHotelSearchMobile = location.pathname === '/hotels';

  // For public routes, render with header and footer
  return (
    <>
      <div className={(hideChromeOnMobile ? 'hidden md:block sticky top-0 z-40' : 'sticky top-0 z-40') + ' app-chrome-header'}>
        <SimpleHeader />
      </div>
      <div className={hideChromeOnMobile ? '' : 'pb-16 md:pb-0'}>
        {children}
      </div>
      <div className={hideChromeOnMobile || isHotelSearchMobile || hideDesktopFooterOnMobile ? 'hidden md:block' : ''}>
        <Footer />
      </div>
      {/* Round-trip results keeps its bottom booking widget where the footer menu
          would be — same as its desktop widget owning that zone. */}
      <div className={(hideChromeOnMobile || location.pathname === '/flights/roundtrip-results') ? 'hidden md:block' : ''}>
        <MobileFooter />
      </div>
    </>
  );
};

export default ConditionalLayout;
